export default "__VITE_ASSET__Js_L0gPx__"